// My Stocks — v3 rebuild. V2MyStocksPage now renders the merged v3 surface
// (<MyStocks/> from src/v2/v3/MyStocks.jsx): a Watchlist | Holdings sub-tab
// switch with its own shell (TickerStrip + BottomNav). The old AppLayout +
// MyPortfolioInner + WatchlistInner composition is no longer used here.
//
// The legacy inner component FILES (MyPortfolio.jsx, Watchlist.jsx,
// components/watchlist/*, components/portfolio/*) are intentionally left in
// place — a later orphan-cleanup pass handles those. This page just stops
// importing them.

import { MyStocks } from '@/v2/v3/MyStocks'

export function V2MyStocksPage() {
  return <MyStocks />
}
